import React from 'react'
import { Box, Container } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { FAQ_VARIANTS } from './FAQ.const'
import { useFAQ } from './FAQ.hooks'

const FAQ = props => {
	const [{ classes, metaData, variant, Element }] = useFAQ(props)

	return (
		<Box className={clsx(classes.root, classes[variant], 'section-faq')}>
			<Container className={clsx(classes.content, 'section-faq-content')}>
				{Element && <Element metaData={metaData} />}
			</Container>
		</Box>
	)
}

FAQ.propTypes = {
	variant: PropTypes.oneOf(Object.values(FAQ_VARIANTS)),
}

FAQ.defaultProps = {
	variant: FAQ_VARIANTS.VARIANT_1,
}

export default FAQ
